import { render } from "./TermsCheckBox.vue?vue&type=template&id=0040debe&ts=true"
import script from "./TermsCheckBox.vue?vue&type=script&lang=ts"
export * from "./TermsCheckBox.vue?vue&type=script&lang=ts"

import exportComponent from "/home/runner/work/angelleague-front/angelleague-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__